(function(){
  function num(v){ return parseFloat(String(v == null ? '' : v).replace(/[^0-9.]/g,'')) || 0; }
  function money(n){ return '$' + n.toFixed(2); }
  function restoreBadges(){
    document.querySelectorAll('label.el-product-form__option').forEach(function(label){
      var badge = label.querySelector('.option-label__heading .el-product-form__badge');
      if(!badge) return;
      var content = label.querySelector('.el-product-form__option-content');
      if(content){ content.insertBefore(badge, content.firstChild); delete badge.dataset.inlined; }
    });
  }
  function updateSave(){
    document.querySelectorAll('label.el-product-form__option').forEach(function(label){
      var input = label.querySelector('input[name="quantity_option"]');
      var saveEl = label.querySelector('.option-label__heading p.t-medium');
      if(!input || !saveEl) return;
      var p = num(input.dataset.price), c = num(input.dataset.comparePrice);
      if(c > 0 && p > 0 && c > p){ saveEl.textContent = 'You save $' + Math.round(c - p); }
    });
  }
  function updateBadges(){
    var spans = document.querySelectorAll('.el-product-form__badge span');
    if(spans[0] && spans[0].textContent !== 'Most Popular') spans[0].textContent = 'Most Popular';
    if(spans[1] && spans[1].textContent !== 'Free Shipping') spans[1].textContent = 'Free Shipping';
  }
  function updatePriceRow(){
    var checked = document.querySelector('input[name="quantity_option"]:checked');
    if(!checked) return;
    var p = num(checked.dataset.price), c = num(checked.dataset.comparePrice);
    var pe = document.querySelector('[data-pr-price]'), ce = document.querySelector('[data-pr-compare]'), se = document.querySelector('[data-pr-save]');
    if(pe && p > 0) pe.textContent = money(p);
    if(ce && c > 0) ce.textContent = money(c);
    if(se && c > p) se.textContent = '$' + Math.round(c - p);
  }
  function updateLocks(){
    var checked = document.querySelector('input[name="quantity_option"]:checked');
    if(!checked) return;
    var label = checked.closest('label.el-product-form__option');
    if(!label) return;
    var titleEl = label.querySelector('p.t-bold');
    var title = titleEl ? titleEl.textContent : '';
    var isBuyOne = /buy\s*one/i.test(title);
    var inclusions = document.querySelectorAll('.el-product-inclusion');
    inclusions.forEach(function(inc,i){
      if(i === 0){ inc.classList.add('active'); return; }
      if(isBuyOne){ inc.classList.remove('active'); }
      else { inc.classList.add('active'); }
    });
  }
  function updateAll(){ restoreBadges(); updateSave(); updateBadges(); updatePriceRow(); updateLocks(); }
  document.addEventListener('change', function(e){
    if(!e.target) return;
    if((e.target.classList && e.target.classList.contains('subsciption-block__radio')) || e.target.name === 'quantity_option'){
      setTimeout(updateAll, 90);
    }
  }, true);
  if(document.readyState !== 'loading'){ updateAll(); }
  else { document.addEventListener('DOMContentLoaded', updateAll); }
  var runs = 0;
  var iv = setInterval(function(){ updateAll(); if(++runs >= 12) clearInterval(iv); }, 800);
})();
